/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Chat_Tool_Confirm_Expired_AtInputs */



/**
* | output |
* | --- |
* | "This approval expired at {time}; nothing was run. Ask again to retry." |
*
* @param {Chat_Tool_Confirm_Expired_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_expired_at = /** @type {((inputs: Chat_Tool_Confirm_Expired_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Expired_AtInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Bestätigung ist um ${i?.time} abgelaufen; es wurde nichts ausgeführt. Fragen Sie erneut nach, um es noch einmal zu versuchen.`)
	return /** @type {LocalizedString} */ (`This approval expired at ${i?.time}; nothing was run. Ask again to retry.`)
});